import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push,
  replace
} from 'react-router-redux';
import {
  Container,
  Header,
  Icon,
  Menu,
  Segment
} from 'semantic-ui-react';
import {
  Link
} from 'react-router-dom';
import {
  Route
} from 'react-router-dom';
import feathersConnect from './../../../providers/feathersConnect';
import NominaPersonasView from './NominaPersonasView';

class PersonasView extends Component {

  constructor (props) {
    super(props);
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <Container style={{ padding: 16 }}>
        <Header as="h2">
          <Icon name="users" />
          <Header.Content>
            Nomina de Personas
            <Header.Subheader>
              Administrar Nomina de Personas
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Menu attached="top" tabular>
          <Menu.Item
            as={Link} to="/personas/nomina"
            active={!!window.location.pathname.match(new RegExp(`^/personas/nomina/?$`))}
            name="nomina" />
        </Menu>
        <Route path={`${this.props.match.url}/nomina`} render={() => {
          return (
            <Segment attached="bottom">
              <NominaPersonasView />
            </Segment>
          );
        }} />
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    PersonasView.mapStateToProps,
    PersonasView.mapDispatchToProps
  )(PersonasView)
);



// WEBPACK FOOTER //
// ./client/components/pages/personas/PersonasView.js